export default function Burger($, selectors, undefined) {
    return function() {
        selectors.get('#burger').on('click', function () {
            $(this).toggleClass('open');
            selectors.get('header nav').toggleClass('open');
        });
    }
}

